import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type TabSwitchAlertLevel = 'banner' | 'warning' | null;

@Component({
  selector: 'lib-exam-tab-switch-alert',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
  templateUrl: './exam-tab-switch-alert.component.html',
  styleUrls: ['./exam-tab-switch-alert.component.scss'],
})
export class ExamTabSwitchAlertComponent {
  /** Nombre total de détections (piloté par le parent) */
  switchCount = input.required<number>();

  /** Émis quand l'utilisateur ferme l'alerte */
  dismissed = output<void>();

  /** Niveau affiché, dérivé du compteur */
  level = computed<TabSwitchAlertLevel>(() => {
    const count = this.switchCount();
    if (count <= 0) return null;
    if (count === 1) return 'banner';
    return 'warning';
  });

  /** Barre de progression : dots remplis = switchCount (max 3) */
  dots = computed(() => {
    const count = this.switchCount();
    return [1, 2, 3].map((i) =>
      i < count ? 'done' : i === count ? 'current' : ''
    );
  });

  dismiss(): void {
    this.dismissed.emit();
  }
}
